export function FeatherIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="26"
      height="28"
      viewBox="0 0 26 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 17.1962H20.9477L16.1352 22.9304H4.48909L2.4668 11.4608L4.87304 8.59375L8 9.5L9.5 17.1962Z"
        fill="currentColor"
        fillOpacity="0.2"
      />
      <path
        d="M7.41695 5.73474L12.229 0L19.0634 5.73474L25.8978 11.4695L21.0857 17.2042L19.0634 5.73474H7.41695Z"
        fill="currentColor"
        fillOpacity="0.5"
      />
      <rect
        width="11.6464"
        height="11.6464"
        transform="matrix(1 0 0.173648 0.984808 7.37598 5.72656)"
        fill="currentColor"
        fillOpacity="0.34"
      />
      <rect
        width="11.6464"
        height="11.6464"
        transform="matrix(1 0 0.173648 0.984808 12.3257 0)"
        fill="currentColor"
      />
      <path
        d="M0 27.4652L22.0311 0.484375L23.9237 2.18281L0.582321 27.999L0 27.4652Z"
        fill="currentColor"
      />
    </svg>
  );
}
